import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'


export const cscStoreLocator = {
  height: css`var(--csc-store-locator-height, 880px)`
}

export const style: CSSResult = css`
  .csc-store-locator-container {
    display: flex;
    flex-flow: column;
    row-gap: ${csSpacing.spacing08};
  }

  .list-view.desktop {
    min-width: 430px;
  }
  
  .toggle-button {
    align-self: end;
  }
  
  .map-view {
    display: flex;
    flex-direction: column;
    height: ${cscStoreLocator.height};
  }
  
  .map-view.desktop {
    flex: 1;
  }
  
  .hidden {
    display: none;
  }
  
  csc-store-list {
    position: relative;
  }
`
